import React from 'react';
import { Route, Switch } from 'react-router-dom';

import DataAnalysisMenu from './data_analysis_menu';
import QualityControl from './quality-control';
import Reports from './reports';

class DataAnalysis extends React.Component {
	render() {
		return (
			<Switch>
				<Route exact path="/data-analysis" component={DataAnalysisMenu} />
				<Route exact path="/data-analysis/quality-control" component={QualityControl} />
				<Route exact path="/data-analysis/reports" component={Reports} />
			</Switch>
		);
	}
}

export default DataAnalysis;
